import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Typography,
  Radio,
  FormControlLabel,
  CircularProgress,
  RadioGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import {
  fetchUsers
} from 'store/actions';
import SearchIcon from '@material-ui/icons/Search';
import { Constants } from 'utilities/constants';
import ClearIcon from '@material-ui/icons/Clear';

const AssignModal = ({
  module,
  isOpen,
  classes,
  selectedRows,
  users,
  assignTasks,
  setIsOpen,
  fetchUsers
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [filterInput, setFilterInput] = useState('');

  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      fetchUsers();
    }
  }, [isOpen])

  useEffect(() => {
    if (users.length > 0 && isLoading) {
      setTimeout(() => setIsLoading(false), 200);
    }
  }, [users])

  function handleAssign() {
    assignTasks(isPostAcq ? 'postAcqTask' : 'txnOpp', selectedRows, selectedUserId);
    setSelectedUserId(null);
  }

  const handleFilterInputChange = input => {
    setFilterInput(input);
  }

  function getFilteredUsers() {
    const systemUsers = [
      Constants.Username.AUTOCALC,
      Constants.Username.MLSFEED,
      Constants.Username.CRMFEED
    ]
    const systemUsersRemoved = users.filter(user => !systemUsers.includes(user.name));
    if (!filterInput) return systemUsersRemoved;

    const cleanedInput = filterInput.trim().toLowerCase();
    return systemUsersRemoved.filter(user => {
      return user.name.includes(cleanedInput) || user.fullName.toLowerCase().includes(cleanedInput);
    });
  }

  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') return; // updated handling for disableBackdropClick
    setIsOpen(false);
  }

  const isPostAcq = module === Constants.Module.POSTACQ
  const selectedMessage = isPostAcq
    ? `${selectedRows.length} task${selectedRows.length > 1 ? 's' : ''} selected`
    : `${selectedRows.length} opportunit${selectedRows.length > 1 ? 'ies' : 'y'} selected`
  return (
    <Dialog
      open={isOpen} onClose={handleClose} maxWidth='sm' fullWidth classes={{ paper: classes.assignDialog }}>
      <DialogTitle disableTypography={true} className={classes.dialogTitleRoot}>
        <Typography variant={'h6'}>
          <span>{`Assign ${isPostAcq ? 'Tasks' : 'Transaction Opportunities'}`}</span>
        </Typography>
        <Typography variant='body1' >{selectedMessage}</Typography>
        <TextField
          className={classes.filterField}
          fullWidth
          type='text'
          size='small'
          variant='outlined'
          disabled={isLoading}
          value={filterInput}
          onChange={e => handleFilterInputChange(e.target.value)}
          InputProps={{
            startAdornment:
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
          }}
        />
      </DialogTitle>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <ClearIcon fontSize="inherit" />
      </IconButton>
      <DialogContent>
        {!isLoading 
          ? <RadioGroup
              name="userGroup"
              value={selectedUserId}
              onChange={e => setSelectedUserId(e.target.value)}
            >
              {getFilteredUsers().map(user =>
                <FormControlLabel value={user.id.toString()} key={user.id} control={<Radio />} label={user.fullName} />)}
            </RadioGroup>
          : <div className={classes.loadingWrapper}>
              <CircularProgress />
            </div>
        }
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleClose}>Cancel</Button>
        <Button variant='contained' color='primary' onClick={() => handleAssign()} disabled={!selectedUserId}>Assign</Button>
      </DialogActions>
    </Dialog>
  );
};

const styles = theme => ({
  assignDialog: {
    // height: '50%',
    minHeight: 350
  },
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  filterField: {
    marginTop: 16
  },
  dialogTitleRoot: {
    paddingBottom: 0
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#ffffff'
  },
});

const mapState = state => {
  return {
    users: state.appState.users
  }
};

const mapDispatch = dispatch => ({
  fetchUsers: () => dispatch(fetchUsers())
});

export default compose(
  withStyles(styles),
  connect(mapState, mapDispatch)
)(AssignModal);